import _ from "lodash";
import { Injectable } from "@angular/core";
import { StringKeyOf } from "@logex/framework/types";

export interface FilterStorage {
    organizationList: _.Dictionary<string>;
    logs: _.Dictionary<string>;
    affiliationList: _.Dictionary<string>;
}

export type FilterStorageKey = StringKeyOf<FilterStorage>;

@Injectable({ providedIn: "root" })
export class LastFilterStorageService {
    private state: FilterStorage;

    constructor() {
        this.state = {
            organizationList: {},
            logs: {},
            affiliationList: {}
        };
    }

    store(key: FilterStorageKey, currentState: _.Dictionary<string>): void {
        this.state[key] = currentState;
    }

    get(key: FilterStorageKey): _.Dictionary<string> {
        return this.state[key];
    }
}
